/**
 * STABILITY-CRITICAL: textos mostrados ao usuário quando o fluxo de saída/limpeza para.
 * Todo texto de falha DEVE dizer se algo foi apagado. Antes de alterar, leia
 * docs/llm/slices/sync-engine.md e alinhe com o responsável pelo sync.
 */
import { TABLE_LABEL } from './pendingGate'
import type { DlqInfo, RefusedInfo } from './pendingGate'

/** "1 fazenda" / "3 fazendas": plural de verdade em vez de "fazenda(s)" (QA HML U7). */
export const contagem = (n: number, singular: string, plural: string) =>
  n === 1 ? `1 ${singular}` : `${n} ${plural}`

export function buildBackupWarnings(
  dlq: DlqInfo,
  refused: RefusedInfo | null,
): string[] {
  const out: string[] = []
  if (refused) {
    const tabelas = Object.keys(refused.byTable)
    const total = tabelas.reduce((s, t) => s + refused.byTable[t], 0)
    const partes = tabelas.map(
      (t) =>
        `${contagem(refused.byTable[t], 'registro', 'registros')} de ${TABLE_LABEL[t] ?? t}`,
    )
    out.push(
      total === 1
        ? `${partes.join(', ')} não está sendo aceito pelo servidor; ficará somente no arquivo de backup.`
        : `${partes.join(', ')} não estão sendo aceitos pelo servidor; ficarão somente no arquivo de backup.`,
    )
  }
  if (dlq.total > 0) {
    // Texto aprovado pelo Filipe (QA HML U10). A quebra por tipo/entidade continua no
    // diagnostico.json do backup e no evento dlq_discarded_on_reset.
    out.push(
      dlq.total === 1
        ? '1 envio antigo que falhou será removido deste aparelho. Uma cópia fica no arquivo de backup.'
        : `${dlq.total} envios antigos que falharam serão removidos deste aparelho. Uma cópia fica no arquivo de backup.`,
    )
  }
  return out
}

export type FailureLike = { reason: string; message?: string }

export function describeFailure(f: FailureLike): string {
  switch (f.reason) {
    case 'blocked_cancelled':
      return 'Operação cancelada. Nada foi apagado.'
    case 'backup_failed':
      return 'Não foi possível gerar ou salvar o backup. Nada foi apagado. Tente de novo.'
    case 'backup_cancelled':
      return 'O backup não foi salvo. Nada foi apagado.'
    case 'changed_after_backup':
      return 'Os dados mudaram depois do backup. Nada foi apagado; tente de novo.'
    case 'precondition_offline':
      return 'Sem internet. Conecte-se e tente de novo. Nada foi apagado.'
    case 'precondition_busy':
      return 'Há uma sincronização em andamento. Aguarde terminar e tente de novo. Nada foi apagado.'
    case 'snapshot_failed':
    case 'marker_failed':
      return 'Não foi possível preparar a limpeza com segurança. Nada foi apagado.'
    default:
      return f.message
        ? `${f.message} Nada foi apagado.`
        : 'Ocorreu um erro. Nada foi apagado.'
  }
}
